import { SvgIcon } from '@mui/material';
import React from 'react';

const PandoraIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="Calque_2"
        viewBox="0 0 97.16 109.23"
      >
        <defs>
          <style>
            {`
              .cls-1 {
                fill: url(#Dégradé_sans_nom_39);
              }

              .cls-2 {
                fill: url(#Dégradé_sans_nom_37);
              }

              .cls-3 {
                fill: #474747;
              }

              .cls-4 {
                fill: #1a1a1c;
              }

              .cls-5 {
                opacity: .1;
              }

              .cls-6 {
                fill: url(#Dégradé_sans_nom_40);
              }

              .cls-7 {
                fill: url(#Dégradé_sans_nom_38);
              }
            `}
          </style>
          <linearGradient
            id="Dégradé_sans_nom_37"
            data-name="Dégradé sans nom 37"
            x1="17.43"
            y1="21.48"
            x2="44.1"
            y2="43.34"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".28" stopColor="#fc2e25" />
            <stop offset="1" stopColor="#bd241c" />
          </linearGradient>
          <linearGradient
            id="Dégradé_sans_nom_39"
            data-name="Dégradé sans nom 39"
            x1="47.95"
            y1="61.72"
            x2="74.64"
            y2="83.6"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".28" stopColor="#00a849" />
            <stop offset="1" stopColor="#00692d" />
          </linearGradient>
          <linearGradient
            id="Dégradé_sans_nom_40"
            data-name="Dégradé sans nom 40"
            x1="81.26"
            y1="17.31"
            x2="48.61"
            y2="49.96"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".33" stopColor="#ffb600" />
            <stop offset="1" stopColor="#bf8900" />
          </linearGradient>
          <linearGradient
            id="Dégradé_sans_nom_38"
            data-name="Dégradé sans nom 38"
            x1="27.86"
            y1="79.94"
            x2="43.04"
            y2="64.75"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".1" stopColor="#2785fa" />
            <stop offset="1" stopColor="#1e64ba" />
          </linearGradient>
        </defs>
        <g id="Logotype">
          <g>
            <g>
              <g>
                <polygon
                  className="cls-2"
                  points="46.16 0 46.16 41.71 35.67 41.71 35.67 52.21 0 52.21 46.16 0"
                />
                <polygon
                  className="cls-1"
                  points="97.16 57.02 50.97 109.23 50.97 67.53 61.49 67.53 61.49 57.02 97.16 57.02"
                />
                <polygon
                  className="cls-6"
                  points="83.92 52.21 61.49 52.21 61.49 41.71 50.97 41.71 50.97 10.04 83.92 52.21"
                />
                <polygon
                  className="cls-7"
                  points="46.16 67.53 46.16 99.21 13.21 57 35.67 57 35.67 67.53 46.16 67.53"
                />
              </g>
              <g className="cls-5">
                <polygon
                  className="cls-4"
                  points="46.16 9.73 46.16 41.71 35.67 41.71 35.67 52.21 8.59 52.21 46.16 9.73"
                />
                <polygon
                  className="cls-4"
                  points="88.55 57.02 50.97 99.5 50.97 67.53 61.49 67.53 61.49 57.02 88.55 57.02"
                />
                <polygon
                  className="cls-4"
                  points="61.49 52.21 61.49 41.71 50.97 41.71 50.97 18.12 77.61 52.21 61.49 52.21"
                />
                <polygon
                  className="cls-4"
                  points="46.16 67.53 46.16 91.12 19.51 57 35.67 57 35.67 67.53 46.16 67.53"
                />
              </g>
            </g>
            <polygon
              className="cls-3"
              points="52.94 47.61 44.22 47.61 41.57 47.61 41.57 50.25 41.57 58.98 41.57 61.63 44.22 61.63 52.94 61.63 55.59 61.63 55.59 58.98 55.59 50.25 55.59 47.61 52.94 47.61"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default PandoraIcon;
